module.exports = __webpack_public_path__ + "static/SA-49aaeac5bc7f84423cc1168532ae9a3c.svg";